(function () {
  'use strict';

  var TRACKING_NAMESPACE = 'clawlab_tracking';
  var SCROLL_DEPTHS = [25, 50, 75, 100];
  var firedOnce = Object.create(null);

  window.dataLayer = window.dataLayer || [];

  function isHomepage() {
    return document.body && (
      document.body.classList.contains('template-index') ||
      window.location.pathname === '/' ||
      window.location.pathname.replace(/\/$/, '') === ''
    );
  }

  function getDeviceType() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
  }

  function getTrafficSource() {
    var params = new URLSearchParams(window.location.search);
    return (
      params.get('utm_source') ||
      params.get('source') ||
      document.referrer ||
      'direct'
    );
  }

  function normalizeValue(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === 'null') return null;
    return value;
  }

  function getDatasetParams(element) {
    var params = {};

    if (!element || !element.dataset) return params;

    Object.keys(element.dataset).forEach(function (key) {
      if (key.indexOf('trackParam') !== 0) return;

      var paramName = key
        .replace(/^trackParam/, '')
        .replace(/^[A-Z]/, function (match) { return match.toLowerCase(); })
        .replace(/[A-Z]/g, function (match) { return '_' + match.toLowerCase(); });

      if (paramName) {
        params[paramName] = normalizeValue(element.dataset[key]);
      }
    });

    return params;
  }

  function getProductParams(element) {
    var productRoot = element && element.closest('[data-product-options], [data-product-id], [data-pr-id]');
    var params = {};

    if (!productRoot) return params;

    if (productRoot.dataset.productId) params.product_id = productRoot.dataset.productId;
    if (productRoot.dataset.prId) params.product_id = productRoot.dataset.prId;

    if (productRoot.dataset.productOptions) {
      try {
        var options = JSON.parse(productRoot.dataset.productOptions);
        if (options.id) params.product_id = String(options.id);
        if (options.handle) params.product_handle = options.handle;
      } catch (error) {
        // Keep tracking resilient if a theme data attribute is not valid JSON.
      }
    }

    var title = productRoot.querySelector('.t4s-product-title, .t4s-pr-title, [data-product-title]');
    if (title && title.textContent) {
      params.product_name = title.textContent.trim();
    }

    return params;
  }

  function getProductParamsFromLink(link) {
    var params = getProductParams(link);
    var productCard = link && link.closest('.our-products-card, .t4s-product, .type_mn_product_card');
    var title;

    if (link && link.href) {
      try {
        params.product_handle = new URL(link.href, window.location.href).pathname
          .split('/products/')[1]
          .split('/')[0]
          .split('?')[0]
          .split('#')[0];
      } catch (error) {
        // Ignore malformed URLs and keep the click event usable.
      }
    }

    if (!params.product_name && productCard) {
      title = productCard.querySelector(
        '.our-product-card-title, .t4s-product-title, .t4s-pr-title, .t4s-product-menu-card__title, [data-product-title]'
      );

      if (title && title.textContent) {
        params.product_name = title.textContent.trim().replace(/\s+/g, ' ');
      }
    }

    return params;
  }

  function buildBaseParams() {
    return {
      device_type: getDeviceType(),
      traffic_source: getTrafficSource(),
      page_url: window.location.href
    };
  }

  function shouldFireOnce(eventName, params) {
    var key = [
      eventName,
      params.section_name || '',
      params.product_id || '',
      params.product_name || '',
      params.depth || ''
    ].join('|');

    if (firedOnce[key]) return false;
    firedOnce[key] = true;
    return true;
  }

  function track(eventName, params, options) {
    var eventParams;

    if (!eventName || typeof eventName !== 'string') return;

    eventParams = Object.assign({}, buildBaseParams(), params || {});

    if (!eventParams.event_id) {
      eventParams.event_id = [
        TRACKING_NAMESPACE,
        eventName,
        Date.now(),
        Math.random().toString(36).slice(2, 10)
      ].join('_');
    }

    if (options && options.once && !shouldFireOnce(eventName, eventParams)) return;

    window.dataLayer.push(Object.assign({ event: eventName }, eventParams));

    if (window.Shopify && window.Shopify.designMode) {
      console.log('[Clawlab Tracking]', eventName, eventParams);
    }
  }

  function bindDeclarativeClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target.closest('[data-track-event]');
      var params;

      if (!target) return;

      params = Object.assign(
        {},
        getProductParams(target),
        getDatasetParams(target)
      );

      if (target.dataset.trackSection) params.section_name = target.dataset.trackSection;
      if (target.dataset.trackCta) params.cta_text = target.dataset.trackCta;

      track(target.dataset.trackEvent, params, { once: target.dataset.trackOnce === 'true' });
    });
  }

  function bindDeclarativeViews() {
    var viewElements = Array.prototype.slice.call(document.querySelectorAll('[data-track-view]'));
    var standardViewElements = viewElements.filter(function (element) {
      return element.dataset.trackViewMode !== 'full';
    });
    var fullViewElements = viewElements.filter(function (element) {
      return element.dataset.trackViewMode === 'full';
    });

    function fireView(element) {
      var params = getDatasetParams(element);
      if (element.dataset.trackSection) params.section_name = element.dataset.trackSection;

      track(element.dataset.trackView, params, { once: true });
    }

    if (standardViewElements.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var target;

          if (!entry.isIntersecting) return;

          target = entry.target;
          fireView(target);
          observer.unobserve(target);
        });
      }, { threshold: 0.35 });

      standardViewElements.forEach(function (element) {
        observer.observe(element);
      });
    }

    if (!fullViewElements.length) return;

    function checkFullViews() {
      fullViewElements = fullViewElements.filter(function (element) {
        var rect = element.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        var visibleRatio = rect.height > 0 ? visibleHeight / rect.height : 0;
        var isFullyVisible = rect.top >= 0 && rect.bottom <= viewportHeight;
        var isMostlyVisibleWhenTooTall = rect.height > viewportHeight && visibleRatio >= 0.9;

        if (isFullyVisible || isMostlyVisibleWhenTooTall) {
          fireView(element);
          return false;
        }

        return true;
      });

      if (!fullViewElements.length) {
        window.removeEventListener('scroll', checkFullViews);
        window.removeEventListener('resize', checkFullViews);
      }
    }

    window.addEventListener('scroll', checkFullViews, { passive: true });
    window.addEventListener('resize', checkFullViews);
    checkFullViews();
  }

  function bindHomepageScrollDepth() {
    var firedDepths = {};

    if (!isHomepage()) return;

    function handleScrollDepth() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var pageHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      ) - window.innerHeight;
      var percent = pageHeight > 0 ? Math.floor((scrollTop / pageHeight) * 100) : 100;

      SCROLL_DEPTHS.forEach(function (depth) {
        if (firedDepths[depth] || percent < depth) return;

        firedDepths[depth] = true;
        track('homepage_scroll_depth_' + depth, {
          section_name: 'homepage',
          depth: depth
        }, { once: true });
      });
    }

    window.addEventListener('scroll', handleScrollDepth, { passive: true });
    window.addEventListener('resize', handleScrollDepth);
    handleScrollDepth();
  }

  function bindHomepageAddToCart() {
    if (!isHomepage()) return;

    document.addEventListener('click', function (event) {
      var button = event.target.closest(
        'button[name="add"], [data-atc], .t4s-pr-addtocart, .t4s-product-form__submit'
      );
      var params;

      if (!button) return;

      params = Object.assign({}, getProductParams(button), {
        section_name: button.closest('[data-section-id]') && button.closest('[data-section-id]').dataset.sectionId || 'homepage',
        cta_text: button.textContent ? button.textContent.trim() : 'Add to cart'
      });

      track('homepage_add_to_cart', params);
    });
  }

  function bindHomepageProductPageLinks() {
    if (!isHomepage()) return;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      var url;
      var section;
      var params;

      if (!link) return;

      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) return;

      section = link.closest('[data-track-section], [data-section-id], section, .shopify-section');
      params = Object.assign({}, getProductParamsFromLink(link), {
        section_name: link.dataset.trackSection ||
          section && section.dataset && (section.dataset.trackSection || section.dataset.sectionId) ||
          'homepage',
        cta_text: link.dataset.trackCta || (link.textContent ? link.textContent.trim() : ''),
        destination_url: url.href
      });

      track('homepage_to_product_page', params);
    }, true);
  }

  function init() {
    bindDeclarativeClicks();
    bindDeclarativeViews();
    bindHomepageScrollDepth();
    bindHomepageAddToCart();
    bindHomepageProductPageLinks();
  }

  window.clawlabTrack = track;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
